import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .elle-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    /* The block sets align-items on the grid, which would collapse the shared
       rule inside its grid area; stretch it so the border-bottom lands at the
       block's bottom. */
    .horizontal-rule {
      align-self: stretch;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
      padding-bottom: calc(var(--text-stack-header-gap) - var(--block-row-gap));
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    .desktop-only {
      display: none;
    }

    .mobile-only {
      display: inherit;
    }

    /* h1 and h3 (image titles) now ride the shared type defaults; the old
       rules pinned the desktop h3 size at every width. */
    img {
      max-width: 100%;
    }

    .images {
      display: flex;
      flex-wrap: wrap;
      gap: calc(60rem / var(--default-rem-px-count));
    }

    /* Cards are driver-card elements; spacing here is padding-based, so the
       element's gap is zeroed and natural-width images stay centered. */
    .image-wrapper {
      width: 100%;
      --driver-card-gap: 0;
      --driver-card-image-width: auto;
      --driver-card-image-fit: initial;
    }

    .image-wrapper::part(image) {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: calc(30rem / var(--default-rem-px-count));
    }

    /* Elle titles ride the full title scale, not the card default (label). */
    .image-wrapper::part(title) {
      font-size: var(--fs-title);
      line-height: var(--lh-title);
      letter-spacing: var(--ls-title);
      font-weight: var(--fw-regular);
    }

    /* Card descriptions run at the body scale. */
    .image-wrapper::part(description) {
      padding: calc(20rem / var(--default-rem-px-count)) 0;
      text-wrap: pretty;
      font-size: var(--fs-body);
      line-height: var(--lh-body);
      letter-spacing: var(--ls-body);
    }

    @media (min-width: 600px) {
      .header {
        padding-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .elle-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
        align-items: start;
      }

      /* Top-row texts share a first baseline. */
      .header {
        grid-column: 2 / 8;
        grid-row: 2;
        align-self: baseline;
      }

      .description {
        grid-column: 8 / 12;
        grid-row: 2;
        align-self: baseline;
      }

      .desktop-only {
        display: inherit;
      }

      .mobile-only {
        display: none;
      }

      .images {
        grid-column: 2 / 14;
        grid-row: 3;
        gap: calc(2 * var(--between-column-padding))
          var(--between-column-padding);
        display: grid;
        max-width: 100%;
        grid-template-columns: repeat(3, 1fr);
      }

      .image-wrapper::part(description) {
        max-width: 66.66%;
      }
    }
  `,
];
